module.exports = __webpack_public_path__ + "img/Dantam Bridal 18.4159c8f4.jpg";